import React from 'react'

import clsx from 'clsx'
import { Loader2Icon } from 'lucide-react'

type ToggleVariant = 'rounded' | 'rectangular'

export const PrivateLiveToggle: React.FC<{
  isOn: boolean
  onToggle: () => void
  variant?: ToggleVariant
  disabled?: boolean
  loading?: boolean
}> = ({ isOn, onToggle, variant = 'rounded', disabled = false, loading }) => {
  const isRectangular = variant === 'rectangular'

  return (
    <div className="flex items-center">
      <button
        onClick={disabled ? undefined : onToggle}
        disabled={disabled}
        className={clsx(
          'relative inline-flex items-center transition-colors focus:outline-none',
          isRectangular
            ? 'h-[42px] w-[94px] rounded-lg border border-SeabiscuitGray500ThemeColor border-solid '
            : 'h-[26px] w-[68px] rounded-full',
          isOn
            ? 'bg-SeabiscuitGreenThemeColor'
            : isRectangular
              ? 'bg-white'
              : 'bg-SeabiscuitDark200ThemeColor/10'
        )}
      >
        <span
          className={clsx(
            'absolute font-medium transition-all duration-200',
            isRectangular ? 'text-sm' : 'text-xs',
            isRectangular
              ? isOn
                ? 'left-4 text-white'
                : 'right-4 text-SeabiscuitDark200ThemeColor/50'
              : isOn
                ? 'left-3 text-white'
                : 'right-3 text-SeabiscuitDark200ThemeColor/50'
          )}
        >
          {isOn ? 'Live' : 'Pvt.'}
        </span>

        <div
          className={clsx(
            'relative inline-block transform transition-transform z-10',
            isRectangular
              ? 'h-[30px] w-[30px] rounded-md bg-SeabiscuitDark200ThemeColor/15'
              : 'h-[20px] w-[20px] bg-white rounded-full',
            isRectangular
              ? isOn
                ? 'translate-x-[58px] !bg-white'
                : 'translate-x-[4px]'
              : isOn
                ? 'translate-x-[44px]'
                : 'translate-x-[4px]'
          )}
        >
          {loading && (
            <div className="absolute z-20 left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 text-SeabiscuitMainThemeColor">
              <Loader2Icon className="animate-spin w-4" />
            </div>
          )}
        </div>
      </button>
    </div>
  )
}
